import * as React from "react";
import {cx} from "emotion";

import "./tabs.scss";

import {cs}        from "@Common/react/chain-services";
import {UseState}  from "@Common/react/use-state";
import {equalDeep} from "@Common/utils/objects";

export const Tabs = ({tabs, getLabel, initValue, next}) => cs(
    ["focused", (_, next) => UseState({initValue, next})],
    ({focused}) => next({
        currentTab: focused.value,
        renderHeader: () => (
            <div className="tabs-5gg">
                {tabs.map((tab, i) => (
                    <div
                        className={cx("tab", {
                            selected: (
                                equalDeep(focused.value, tab)
                            ),
                        })}
                        key={i}
                        xd-qa-type="tab"
                        xd-qa-name={getLabel(tab)}
                        onClick={() => {
                            focused.onChange(tab);
                        }}
                    >
                        {getLabel(tab)}
                    </div>
                ))}
            </div>
        ),
    }),
);
